import { z } from 'zod';
import { CAL_TAG_COLORS } from '../../events/cal-tag-colors.js';
import { CAL_TAG_MAX_NEW_TAGS_PER_REQUEST } from '../../events/cal-tag-max-new-tags-per-request.js';
import { normalizeTagName } from '../../events/normalize-tag-name.js';
import { calTagNameSchema } from './cal-tag-name-schema.js';
/** Tags to create when the template or event is saved; the same name twice (ignoring case) is one tag. */
export const newTagsSchema = z
    .array(z.object({
    name: calTagNameSchema,
    color: z.enum(CAL_TAG_COLORS).optional().nullable(),
}))
    .max(CAL_TAG_MAX_NEW_TAGS_PER_REQUEST, `At most ${CAL_TAG_MAX_NEW_TAGS_PER_REQUEST} new tags can be added at once.`)
    .refine((tags) => new Set(tags.map((tag) => normalizeTagName(tag.name))).size === tags.length, 'Each new tag can only be added once.')
    .optional()
    .default([]);
//# sourceMappingURL=new-tags-schema.js.map